module.exports = __webpack_public_path__ + "static/media/kneecap-up-2.a387f2fc.png";